import { TableVisibility } from '@/components/data-table/DataTable';
import { Color } from '@/models/Color';
import { ProductVariant } from '@/models/ProductVariant';
import { Size } from '@/models/Size';
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';

@Component<AddProductAttributesVariantsStep>({})
export default class AddProductAttributesVariantsStep extends Vue {
  // #region @PropSyncs

  @PropSync('selelectedProductsSync')
  protected selectedProducts!: ProductVariant[];

  // #endregion

  // #region @Props

  @Prop({ default: '1' })
  protected step!: string;

  @Prop({ default: () => new ProductVariant() })
  protected product!: ProductVariant;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props

  protected visibility: TableVisibility = {
    checkboxes: true,
    limit: false,
    search: false,
    title: false,
    total: false,
    pagination: false,
    scrollable: true,
  };

  // #endregion

  // #region Lifecycle Hooks / Init
  // #endregion

  // #region Handlers

  protected onCloseButtonClick(): void {
    this.$emit('close');
  }

  protected onNextButtonClick(): void {
    this.$emit('next');
  }

  protected onPreviousButtonClick(): void {
    this.$emit('previous');
  }

  // #endregion

  // #region Helpers
  // #endregion

  // #region Async methods
  // #endregion

  // #region Getters & Setters

  protected get internalSelectedProducts(): ProductVariant[] {
    return this.selectedProducts;
  }

  protected set internalSelectedProducts(selectedProducts: ProductVariant[]) {
    this.$emit('update:selectedProductsSync', selectedProducts);
  }

  protected get tableOptions() {
    return {
      name: {
        singular: 'Product',
        plural: 'Producten',
      },
      headers: [
        {
          text: 'Name',
          value: 'product_name',
        },
        {
          text: 'SKU',
          value: 'sku',
        },
        {
          text: 'Color',
          value: 'color',
          transform: (color: Color) => {
            return color ? color.name : '';
          }
        },
        {
          text: 'Size',
          value: 'size',
          transform: (size: Size) => {
            return size ? size.name : '';
          }
        },
      ],
      model: new ProductVariant().filter({product: this.product.product_uuid, exclude: this.product.id}),
    };
  }

  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces
// #endregion
